angular.module('elfium').controller('businessCaseListController', ['$scope', '$timeout', 'businessCaseService', 'elfiumToastrService', 'elfiumListFilterFactory', 'elfiumGetNumberFilter', 'reportPhaseOrderFilter', 'REPORT_PHASE', 'TASK_TYPES', 'BUSINESS_CASE_STATES',
    function ($scope, $timeout, businessCaseService, elfiumToastrService, elfiumListFilterFactory, elfiumGetNumberFilter, reportPhaseOrderFilter, REPORT_PHASE, TASK_TYPES, BUSINESS_CASE_STATES) {
        var that = this;
        that.showingDetailIds = [];
        that.businessCases = [];
        that.reportPhaseOrder = [REPORT_PHASE.OTEVRENI_PRIPADU, REPORT_PHASE.DOMLUV_PRVNI_SCHUZKA, REPORT_PHASE.PROBEHLA_PRVNI_SCHUZKA, REPORT_PHASE.CHCI_NABIDKU, 
                                REPORT_PHASE.PRVNI_PREDANI_NABIDKY, REPORT_PHASE.ROZHODNUTI_O_NABIDCE, REPORT_PHASE.ZADANI_DO_PT];
        $scope.filters = {};
        $scope.dateFilters = {
            lastStage: {
                date: {}
            }
        };
        $scope.priorityOptions = {
            '': undefined, 
            'ano': 'true', 
            'ne': 'false'
        };
        $scope.selectedSort = {};
        $scope.lastStages = {};
        $scope.kategorieOptions = [TASK_TYPES.KOTEVRENI, TASK_TYPES.POTREBA, TASK_TYPES.NABIDKA, TASK_TYPES.KUZAVRENI];
        $scope.stavOptions = [BUSINESS_CASE_STATES.WIN, BUSINESS_CASE_STATES.LOST, BUSINESS_CASE_STATES.ACTIVE, BUSINESS_CASE_STATES.NICE_TO_HAVE];

        that.lostFilters = {
            stav: ['""', '"W"', '"A"', '"N"']
        };
        $scope.shouldHideLost = true;
        that.getBusinessCasesWithTasks = function () {
            var lostFilters = that.getLostFilters();
            businessCaseService.searchBusinessCasesWithTasks(lostFilters).then(function (businessCases) {
                that.businessCases = businessCases;
                that.listFilter = new elfiumListFilterFactory($scope, businessCases, $scope.filters, 'businessCases', $scope.dateFilters, 'elfiumDaterangeTwo');
            }, elfiumToastrService.error);
        };
        that.getLostFilters = function () {
            return $scope.shouldHideLost ? that.lostFilters : {};
        };
        that.reloadBusinessCaseWithTasks = function (businessCaseId) {
            businessCaseService.getBusinessCaseWithTasks(businessCaseId).then(function (businessCase) {
                that._updateBusinessCaseInList(businessCase);
                $timeout(that.listFilter.filter, 500);
            }, elfiumToastrService.error);
        };
        that._updateBusinessCaseInList = function (businessCase) {
            for (var i = 0; i < that.businessCases.length; ++i) {
                if (that.businessCases[i].id == businessCase.id) {
                    angular.extend(that.businessCases[i], businessCase);
                    break;
                }
            }
        };
        $scope.hideLost = function () {
            $scope.shouldHideLost = !$scope.shouldHideLost;
            that.getBusinessCasesWithTasks();
        };
        $scope.closeAll = function () {
            that.showingDetailIds = [];
        };
        $scope.openNewBusinessCaseModal = function () {
            businessCaseService.openNewBusinessCaseModal().then(that.getBusinessCasesWithTasks);
        };
        $scope.showOrHideDetail = function (businessCaseId) {
            var showingDetailIndex = that.showingDetailIds.indexOf(businessCaseId);
            if (showingDetailIndex != -1) {
                that.showingDetailIds.splice(showingDetailIndex, 1);
            } else {
                that.showingDetailIds.push(businessCaseId);
            }
        };
        $scope.shouldShowDetail = function (businessCaseId) {
            return that.showingDetailIds.indexOf(businessCaseId) != -1;
        };
        that._getCounts = function () {
            var counts = {
                total: 0,
                important: 0
            };
            angular.forEach($scope.businessCases, function (businessCase) {
                if (businessCase.lastStage) {
                    counts.total += elfiumGetNumberFilter(businessCase.lastStage.volume);
                }
                if (businessCase.priorita) {
                    counts.important++;
                }
            });
            $scope.counts = counts;
        };
        $scope.removeFilters = function () {
            that.listFilter.reset();
        };
        $scope.reportPhaseSort = function (v1, v2) {
            var result = 0;
            if (v1.type == 'string' && v2.type == 'string') {
                var index1 = that.reportPhaseOrder.indexOf(v1.value);
                var index2 = that.reportPhaseOrder.indexOf(v2.value);
                if (index1 == index2) {
                    result = 0;
                } else if (index1 < index2) {
                    result = -1;
                } else if (index1 > index2) {
                    result = 1;
                }
            } else if (v1.type == 'undefined') {
                result = 1
            } else if (v2.type == 'undefined') {
                result = -1;
            }
            return result;
        };
        $scope.$on('reloadBusinessCase', function ($event, businessCaseId) {
            that.reloadBusinessCaseWithTasks(businessCaseId);
        });
        $scope.$watch(that._getCounts);
        that.getBusinessCasesWithTasks();
    }
]);


// WEBPACK FOOTER //
// ./src/app/components/businessCase/businessCaseListController.ts